<template>
  <div class="loginbody">
    <div class="col-md-3" style="margin:auto;padding-top:5%;">
            <auth-layout>
           </auth-layout>
   </div>
  </div>
</template>
<script>
/* eslint-disable */
import authLayout from './login/login.vue'
export default {
  components: {
    authLayout,
  }
}
</script>
<style>
.loginbody{
background-image:url('../../../static/img/galaxy.jpg');
background-position: center;
background-repeat: no-repeat;
background-size: cover;
min-height: 100vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/layout-login.vue